import React from 'react'
import {Route, withRouter, Switch} from 'react-router-dom'
import firebase from 'firebase/app';
import connect from "react-redux/es/connect/connect";
import JavascriptTimeAgo from 'javascript-time-ago'
import ko from 'javascript-time-ago/locale/ko'

import Authentication from './authentication'
import ToastMessage from './toastMessage'
import AlertMessage from './alertMessage'
import LoaderMessage from './loaderMessage'
import TutorialMessage from '../tutorial/tutorialMessage'

import Intro from '../intro'
import LoggedInCheck from '../login/loggedInCheck'
import LoginCallback from '../login/loginCallback'

import Home from '../home'
import About from '../about'

import CreateSchedule from '../schedule/createSchedule'
import ListSchedule from '../schedule/listSchedule'
import FavoriteSchedule from '../schedule/favoriteSchedule'
import CopySchedule from '../schedule/copySchedule'
import EditSchedule from '../schedule/editSchedule'
import Schedule from '../out/schedule'

import Inquiry from '../inquiry'
import Privacy from '../out/privacy'

import {setSearchNaverPlaceData, setNaverPlaceApiData, setNaverTrafficConditionData, setCurrentLocation} from "../../modules/native";
import {showToastMessage} from "../../modules/toast";


const config = {
    apiKey: "AIzaSyBZ4wsLHSy9FGclGh2PlLFMmncyITfGr6Y",
    authDomain: "picnici.firebaseapp.com",
    databaseURL: "https://picnici.firebaseio.com",
    projectId: "picnici",
    storageBucket: "picnici.appspot.com",
    messagingSenderId: "531453068611"
};
firebase.initializeApp(config);

class App extends React.Component {
    constructor(props) {
        super(props);

        // Initialize the desired locales.
        JavascriptTimeAgo.locale(ko)
    }

    componentDidMount(){
        window.document.addEventListener('message', event => {
            try {
                const message = JSON.parse(event.data);
                this.processParentMessage(message);
            } catch (e) {}
        });

        window.addEventListener('message', event => {
            try {
                const message = JSON.parse(event.data);
                this.processParentMessage(message);
            } catch (e) {}
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            this.onRouteChanged();
        }
    }

    onRouteChanged() {
        if(window.isRNWebView === true || window.isRNWebView === 'true') {
            if(this.props.location && this.props.location.pathname){
                if(['/', '/home', '/intro'].indexOf(this.props.location.pathname) !== -1){
                    const message = JSON.stringify({'type': 'REQUEST_SET_CAN_GO_BACK', value: 'FALSE'});
                    window.postMessage(message, "*");
                }else{
                    const message = JSON.stringify({'type': 'REQUEST_SET_CAN_GO_BACK', value: 'TRUE'});
                    window.postMessage(message, "*");
                }
            }
        }
    }

    processParentMessage = (message) => {
        if(!message.type){
            return;
        }

        switch (message.type){
            case 'RESPONSE_CURRENT_LOCATION':
                if(message.data.coords){
                    //alert(JSON.stringify(message.data.coords));
                    //message.data.coords.latitude, message.data.coords.longitude
                    const coords = message.data.coords;
                    const gpsLocation = {y: coords.latitude, x: coords.longitude, lat: coords.latitude, lng: coords.longitude};
                    this.props.setCurrentLocation(gpsLocation);
                    localStorage.setItem('savedGpsLocation', JSON.stringify(gpsLocation));
                }
                break;
            case 'RESPONSE_IS_WEBVIEW_CHECK':
                alert(JSON.stringify(message.data));
                break;
            case 'RESPONSE_SEARCH_NAVER_PLACE':
                if(message.data){
                    if(message.data.result === 'success'){
                        this.props.setSearchNaverPlaceData(message.data.data, message.data.target)
                    }else{
                        this.props.showToastMessage('정보를 가져오는데 오류가 발생하였습니다. 잠시후에 시도해주시기 바랍니다.');
                    }
                }
                break;
            case 'RESPONSE_NAVER_PLACE_API':
                if(message.data){
                    if(message.data.result === 'success'){
                        this.props.setNaverPlaceApiData(message.data.data, message.data.target)
                    }else{
                        this.props.showToastMessage('정보를 가져오는데 오류가 발생하였습니다. 잠시후에 시도해주시기 바랍니다.');
                    }
                }
                break;
            case 'RESPONSE_NAVER_TRAFFIC_CONDITION':
                if(message.data){
                    if(message.data.result === 'success'){
                        this.props.setNaverTrafficConditionData(message.data.data, message.data.target)
                    }else{
                        this.props.showToastMessage('정보를 가져오는데 오류가 발생하였습니다. 잠시후에 시도해주시기 바랍니다.');
                    }
                }
                break;
            default:
                console.error('NO TARGET');
        }
    };

    render() {
        return (
            <div>
                <Authentication/>
                <ToastMessage/>
                <AlertMessage/>
                <LoaderMessage/>
                <TutorialMessage/>

                <header>
                </header>

                <main>
                    <Switch>
                        <Route exact path="/" component={LoggedInCheck}/>
                        <Route exact path="/Intro" component={Intro}/>
                        <Route exact path="/login/loginCallback" component={LoginCallback}/>
                        <Route exact path="/home" component={Home}/>
                        <Route exact path="/about-us" component={About}/>

                        <Route exact path="/createSchedule" component={CreateSchedule}/>
                        <Route exact path="/listSchedule" component={ListSchedule}/>
                        <Route exact path="/favoriteSchedule" component={FavoriteSchedule}/>
                        <Route exact path="/copySchedule" component={CopySchedule}/>
                        <Route exact path="/editSchedule" component={EditSchedule}/>
                        <Route exact path="/inquiry" component={Inquiry}/>
                        <Route exact path="/privacy" component={Privacy}/>

                        <Route exact path="/schedule" component={Schedule}/>
                    </Switch>
                </main>
            </div>
        )
    }
}

const mapStateToProps = ({ user }) => ({
    userInfo: user.userInfo,
});

const mapDispatchToProps = dispatch => ({
    setSearchNaverPlaceData: (data, target) => dispatch(setSearchNaverPlaceData(data, target)),
    setNaverPlaceApiData: (data, target) => dispatch(setNaverPlaceApiData(data, target)),
    setNaverTrafficConditionData: (data, target) => dispatch(setNaverTrafficConditionData(data, target)),
    setCurrentLocation: coordinates => dispatch(setCurrentLocation(coordinates)),
    showToastMessage: message => dispatch(showToastMessage(message))
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(App))
